export default function noInternet() {
	const noInternetElm = document.getElementById('noInternet');
	// インターネット接続 初期状態を確認
	window.addEventListener('load', () => {
		if (!navigator.onLine) {
			noInternetElm.classList.add('active');
			document.body.classList.add('no-scroll');
		}
	});

	// オフラインになったとき
	window.addEventListener('offline', () => {
		noInternetElm.classList.add('active');
		document.body.classList.add('no-scroll');
	});

	//オンラインになったとき
	window.addEventListener('online', () => {
		noInternetElm.classList.remove('active');
		document.body.classList.remove('no-scroll');
	});
}
